module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "suggested"
  }, [_c('h5', {
    staticClass: "suggested__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.posts) ? _c('ul', {
    staticClass: "suggested__list"
  }, _vm._l((_vm.posts), function(post) {
    return _c('li', {
      staticClass: "suggested__post"
    }, [_c('router-link', {
      attrs: {
        "to": post.path
      }
    }, [_vm._v(_vm._s(_vm.clipText(post.title, 60)))]), _vm._v(" "), _c('time', {
      staticClass: "suggested__published"
    }, [_c('icon', {
      attrs: {
        "id": 'clock'
      }
    }), _vm._v("Il y a " + _vm._s(_vm.getElapsedTime({
      date: post.published,
      lang: 'fr'
    })))], 1)], 1)
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11bbfdc8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/blog/SuggestedPosts.vue
// module id = 626
// module chunks = 1